import { render, staticRenderFns } from "./emailFooterEditor.vue?vue&type=template&id=9a9cb698&scoped=true&"
import script from "./emailFooterEditor.vue?vue&type=script&lang=js&"
export * from "./emailFooterEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9cb698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
